import { motion } from "framer-motion";

const TypingDots = () => {
  return (
    <div className="flex items-center my-0.5 space-x-1">
      {[0, 1, 2].map((i) => (
        <motion.span
          key={i}
          className="w-2 h-2 bg-accent-500 rounded-full"
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{
            duration: 1,
            repeat: Infinity,
            delay: i * 0.2, // Stagger effect
          }}
        />
      ))}
    </div>
  );
};

export default TypingDots;
